import React from "react";
import LoadSpinner from "../Elements/LoadSpinner";

function ProductsLoading({size}) {

    const ProductPlaceholder = () => {
        return (
            <li>
                <div className="product product-placeholder">
                    <LoadSpinner />
                </div>
            </li>
        );
    };
    return (
        <>
            {[...Array(size).keys()].map((key) => (
                <ProductPlaceholder key={key} />
            ))}
        </>
    );
}

export default ProductsLoading;